import { AsyncPipe, DatePipe } from '@angular/common';
import { Component, Input, inject, model, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HTTP_CP_MatchMortgageProducts_Response_MortgageProduct } from '@api-new/mortgageservice';
import { provideComponentStore } from '@ngrx/component-store';
import { NgRepeatDirective } from '@shared-lib/directives/ng-repeat.directive';
import { MonthsToTextPipe } from '@shared-lib/pipes/months-to-text.pipe';
import { ENUM_MortgagePartStepTypeRecord } from '@shared-lib/records/enum-mortgage-part-step-type.record';
import { ButtonDirective } from 'primeng/button';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';
import { LabeledValueInlineContainerComponent } from '../../../../labeled-value-inline-container/labeled-value-inline-container.component';
import { MortgagePartFormValues } from '../../../mortgage-part.form';
import { MortgageFormProductMatchingInfoModel } from '../../models/mortgage-form-product-matching-info.model';
import { SKIPPED_PRODUCT_MATCH_PLACEHOLDER } from '../../mortgage-product-match-form.component';
import { ProductMatchItemComponent } from '../product-match-item/product-match-item.component';
import { ProductMatchItemListStore } from './product-match-item-list.store';

@Component({
  selector: 'cui-product-match-item-list',
  imports: [
    ProductMatchItemComponent,
    AsyncPipe,
    NgRepeatDirective,
    SkeletonModule,
    MonthsToTextPipe,
    DatePipe,
    LabeledValueInlineContainerComponent,
    TooltipModule,
    ButtonDirective,
  ],
  templateUrl: './product-match-item-list.component.html',
  styleUrl: './product-match-item-list.component.scss',
  providers: [provideComponentStore(ProductMatchItemListStore)],
})
export class ProductMatchItemListComponent {
  @Input({ required: true }) set mortgagePartInfo({
    productMatchingInfo,
    mortgagePart,
  }: {
    productMatchingInfo: MortgageFormProductMatchingInfoModel;
    mortgagePart: MortgagePartFormValues;
  }) {
    this.componentStore.getProductsForMatching({ productMatchingInfo, mortgagePart });
  }

  readonly products = output<HTTP_CP_MatchMortgageProducts_Response_MortgageProduct[]>();

  selectedProductId = model<string>();

  private readonly componentStore = inject(ProductMatchItemListStore);

  protected readonly products$ = this.componentStore.products$;
  protected readonly mortgagePartInfo$ = this.componentStore.mortgagePartInfo$;
  protected readonly isLoadingProducts$ = this.componentStore.isLoadingProducts$;
  protected readonly isLoadingMoreProducts$ = this.componentStore.isLoadingMoreProducts$;
  protected readonly isLastPage$ = this.componentStore.isLastPage$;

  protected readonly ENUM_MortgagePartStepTypeRecord = ENUM_MortgagePartStepTypeRecord;
  protected readonly SKIPPED_PRODUCT_MATCH_PLACEHOLDER = SKIPPED_PRODUCT_MATCH_PLACEHOLDER;

  constructor() {
    this.products$.pipe(takeUntilDestroyed()).subscribe((products) => this.products.emit(products));
  }

  loadMoreProducts(): void {
    this.componentStore.loadMoreProducts();
  }
}
